import axios from "axios";
import config from "../config";

export const getChart = async (from,to,id) => {
  try {
    const response = await axios({
      method: "get",
      url: `${config.SERVER_URL}/charts?from=${from}&to=${to}&id=${id}`,
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};
